import React, { useState, useContext } from "react";
import Popup from "~/assets/js/components/Popup";
import TextInput from "~/assets/js/components/Forms/TextInput";
import { COUPON } from "~/assets/js/Helpers/coupons";
import { useFormik } from "formik";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";
import { CheckoutContext } from "~/assets/js/pages/Checkout/CheckoutProvider";
import { AddToast } from "~/assets/js/components/Toast";
import { isRequired } from "~/assets/js/Helpers/validators";
import { PlusCircle } from "react-feather";
import { useCartContext } from "~/assets/js/global/cartContext";

const validate = ({ couponCode }) => {
    const errors = {};
    if (isRequired(couponCode)) {
        errors.couponCode = i18n.t("cart.coupons.errors.required");
    }
    return errors;
};

const AddCoupon = ({ disabled }) => {
    const { actions, cartLoading } = useCartContext();
    const { dispatch } = useContext(CheckoutContext);
    const [state, setState] = useState({
        open: false,
    });

    const formik = useFormik({
        initialValues: {
            couponCode: "",
        },

        onSubmit: async ({ couponCode }) => {
            const updatedCoupon = await actions.addCoupon(couponCode);

            if (updatedCoupon.valid !== COUPON.VALID) {
                return (formik.errors.couponCode = i18n.t(
                    "cart.coupons.errors.wrong"
                ));
            }

            formik.resetForm();
            dispatch(
                AddToast(
                    "success",
                    i18n.t("toasts.add_coupon.title", {
                        code: couponCode,
                    })
                )
            );
            return closePopup();
        },
        validate,
    });

    const openPopup = () => {
        setState({ ...state, open: true });
    };
    const closePopup = () => {
        setState({ ...state, open: false });
    };

    const popupConfig = {
        title: i18n.t("cart.coupons.title"),
        handleClose: closePopup,
        open: state.open,
    };

    return (
        <>
            <Button
                onClick={openPopup}
                label={i18n.t("cart.coupons.redeemCode")}
                icon={<PlusCircle />}
                variant="secondary"
                size="XS"
                disabled={disabled}
            />
            <Popup {...popupConfig}>
                <form onSubmit={formik.handleSubmit} id="coupon-form">
                    <TextInput
                        label={i18n.t("cart.coupons.enterCode")}
                        bindName="couponCode"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.couponCode}
                        error={
                            formik.touched.couponCode &&
                            !!formik.errors.couponCode
                        }
                        errorMessage={formik.errors.couponCode}
                        disabled={disabled}
                    />
                    <Button
                        type="submit"
                        loading={cartLoading}
                        loadingLabel={i18n.t("cart.coupons.loading")}
                        label={i18n.t("cart.coupons.save")}
                        variant="secondary"
                        disabled={disabled}
                    />
                </form>
            </Popup>
        </>
    );
};

export default AddCoupon;
